export const RECOMMENDED_CODE_VERIFIER_LENGTH = 96
export const RECOMMENDED_STATE_LENGTH = 32
const PKCE_CHARSET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~"

function base64urlEncode(value) {
    let base64 = btoa(value);
    base64 = base64.replace(/\+/g, "-");
    base64 = base64.replace(/\//g, "_");
    base64 = base64.replace(/=/g, "");
    return base64;
}

export default function generatePKCECodes() {
  const output = new Uint32Array(RECOMMENDED_CODE_VERIFIER_LENGTH);
  crypto.getRandomValues(output);
  const codeVerifier = base64urlEncode(Array.from(output).map((num) => PKCE_CHARSET[num % PKCE_CHARSET.length]).join(""));
  return crypto.subtle.digest("SHA-256", new TextEncoder().encode(codeVerifier)).then((buffer) => {
    let hash = new Uint8Array(buffer);
    let binary = "";
    let hashLength = hash.byteLength;
    for (let i = 0; i < hashLength; i++) {
      binary += String.fromCharCode(hash[i]);
    }
    return binary;
  }).then(base64urlEncode).then((codeChallenge) => ({codeChallenge, codeVerifier}));
}
